"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var PromiseStatusIndicator_1 = __importDefault(require("@components/PromiseStatusIndicator"));
var SelectDropdown_1 = __importDefault(require("@components/SelectDropdown"));
var notifier_1 = __importDefault(require("@utils/notifier"));
var memberSlice_1 = require("@features/SettingsPage/state/memberSlice");
var apiService_1 = __importDefault(require("@common/services/apiService"));
var _store_1 = require("@store");
function MemberItem(props) {
    var member = props.member, roles = props.roles, domain = props.domain;
    var email = member.email, roleId = member.roleId, userId = member.userId;
    var dispatch = (0, _store_1.useAppDispatch)();
    var t = (0, react_i18next_1.useTranslation)(['settings']).t;
    var _a = __read((0, react_1.useState)(), 2), updateRoleStatus = _a[0], setUpdateRoleStatus = _a[1];
    var _b = __read((0, react_1.useState)(roleId), 2), selectedRoleId = _b[0], setSelectedRoleId = _b[1];
    (0, react_1.useEffect)(function () {
        setSelectedRoleId(roleId);
    }, [roleId]);
    var onRoleChanged = function (roleIdStr) {
        var newRoleId = parseInt(roleIdStr);
        var oldRoleId = roleId;
        setSelectedRoleId(newRoleId);
        setUpdateRoleStatus('loading');
        apiService_1.default.postUserRoles({ domain: domain }, { roleId: newRoleId, userId: userId }).then(function (response) {
            setUpdateRoleStatus('success');
            dispatch((0, memberSlice_1.updateRoleForMemberSuccess)(response.data));
            notifier_1.default.success(t('settings:TEAM_MEMBER.UPDATE_ROLE_SUCCESS_MESSAGE'));
        }, function (error) {
            setSelectedRoleId(oldRoleId);
            setUpdateRoleStatus('error');
            notifier_1.default.error(t('settings:TEAM_MEMBER.UPDATE_ROLE_FAILURE_MESSAGE', { EMAIL: email }), error);
        });
    };
    return (react_1.default.createElement("div", { className: "member-item" },
        react_1.default.createElement("div", { className: "member-item__info" },
            react_1.default.createElement("div", { className: "member-item__info__name" }, member.name),
            react_1.default.createElement("div", { className: "member-item__info__email" }, member.email)),
        react_1.default.createElement("div", { className: "member-item__change-role" }, member.isCurrentUser ? (member.role) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(SelectDropdown_1.default, { items: roles.map(function (role) { return ({ id: "".concat(role.id), text: role.role }); }), selectedItemId: "".concat(selectedRoleId), onItemSelected: onRoleChanged }),
            react_1.default.createElement(PromiseStatusIndicator_1.default, { status: updateRoleStatus }))))));
}
exports.default = MemberItem;
